// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "/**\n * Variable Row Styles\n */\n\n.display-variables {\n\t.editor.image-asset {\n\t\tgrid-template-columns: 1fr 30px 30px 30px;\n\t}\n}\n", "",{"version":3,"sources":["VariableRow.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;CACC;EACC,yCAAyC;CAC1C;AACD","file":"VariableRow.css","sourcesContent":["/**\n * Variable Row Styles\n */\n\n.display-variables {\n\t.editor.image-asset {\n\t\tgrid-template-columns: 1fr 30px 30px 30px;\n\t}\n}\n"]}]);
// Exports
module.exports = exports;
